export const AdjustInitializationGuards = {
  isAdjustEnabled: () => false,
  isTrackingAllowed: () => false,
};
